/**
 * Client-side draft persistence for the Studio edit journal (Phase 2).
 * One localStorage slot per clip; server persistence (edit-state.json)
 * is Phase 4 — this keeps an operator's in-progress iteration alive
 * across reloads without touching the backend.
 */
import {
  parseEditState,
  type ClipEditState,
} from "../../../src/lib/clipEditState.ts";

const draftKey = (clipName: string): string => `ql-studio-draft:${clipName}`;

export function loadDraft(clipName: string): ClipEditState | null {
  try {
    return parseEditState(window.localStorage.getItem(draftKey(clipName)));
  } catch {
    return null; // storage unavailable (private mode) → start clean
  }
}

/** Persist the journal; an EMPTY journal removes the slot so "Reset" and
 *  "undid everything" leave no stale draft behind. */
export function saveDraft(clipName: string, state: ClipEditState): void {
  try {
    if (state.journal.length === 0) window.localStorage.removeItem(draftKey(clipName));
    else window.localStorage.setItem(draftKey(clipName), JSON.stringify(state));
  } catch {
    /* quota/private mode — in-memory editing still works */
  }
}

export function clearDraft(clipName: string): void {
  try {
    window.localStorage.removeItem(draftKey(clipName));
  } catch {
    /* noop */
  }
}
